import { StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [];
export const styleDefaults = new Map<string, string>();

export const stylePropertiesForTheme: Array<StylePropertyDefinition> = [
	{
		cp: 'border-color',
		sel: '.comp.compIcon<colorScheme><designType>',
		np: true,
		spv: {
			'-_lightIcon': '<fontColorSix>',
			'-_primary': '<fontColorThree>',
			'-_secondary': '<fontColorFour>',
			'-_tertiary': '<fontColorFive>',
			'-_quaternary': '<fontColorNine>',
			'-_quinary': '<fontColorSeven>',
		},
		gn: 'Border Color',
		dn: 'BorderColor',
		n: 'iconBorderColor<designType><colorScheme>',
	},
	{
		cp: 'color',
		sel: '.comp.compIcon<colorScheme><designType>',
		np: true,
		spv: {
			'_filled-_lightIcon': '<fontColorOne>',
			'_filled-_primary': '<fontColorOne>',
			'_filled-_secondary': '<fontColorTwo>',
			'_filled-_tertiary': '<fontColorOne>',
			'_filled-_quaternary': '<fontColorOne>',
			'_filled-_quinary': '<fontColorTwo>',
			'_rounded-_lightIcon': '<fontColorOne>',
			'_rounded-_primary': '<fontColorOne>',
			'_rounded-_secondary': '<fontColorTwo>',
			'_rounded-_tertiary': '<fontColorOne>',
			'_rounded-_quaternary': '<fontColorOne>',
			'_rounded-_quinary': '<fontColorTwo>',
			'_default-_lightIcon': '<fontColorSix>',
			'_default-_primary': '<fontColorThree>',
			'_default-_secondary': '<fontColorFour>',
			'_default-_tertiary': '<fontColorFive>',
			'_default-_quaternary': '<fontColorNine>',
			'_default-_quinary': '<fontColorSeven>',
			'_outlined-_lightIcon': '<fontColorSix>',
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
		},
		gn: 'Color',
		dn: 'Color Outlined',
		n: 'iconColorOutlined<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compIcon<colorScheme><designType>',
		np: true,
		spv: {
			'_filled-_lightIcon': '<backgroundColorNine>',
			'_filled-_primary': '<backgroundColorOne>',
			'_filled-_secondary': '<backgroundColorTwo>',
			'_filled-_tertiary': '<backgroundColorThree>',
			'_filled-_quaternary': '<backgroundColorFour>',
			'_filled-_quinary': '<backgroundColorFive>',
			'_rounded-_lightIcon': '<backgroundColorNine>',
			'_rounded-_primary': '<backgroundColorOne>',
			'_rounded-_secondary': '<backgroundColorTwo>',
			'_rounded-_tertiary': '<backgroundColorThree>',
			'_rounded-_quaternary': '<backgroundColorFour>',
			'_rounded-_quinary': '<backgroundColorFive>',
		},
		gn: 'Background',
		dn: 'Background Rounded',
		n: 'iconBackgroundRounded<designType><colorScheme>',
	},

	{
		cp: 'border',
		sel: '.comp.compIcon<designType><colorScheme>',
		np: true,
		spv: {
			'_outlined-': '2px solid',
		},
		gn: 'Border',
		dn: 'Border',
		n: 'iconBorder<designType><colorScheme>',
	},
	{
		cp: 'border-radius',
		sel: '.comp.compIcon<designType><colorScheme>',
		np: true,
		spv: {
			'_outlined-': '3px',
			'_filled-': '3px',
			'_rounded-': '50%',
		},
		gn: 'Border Radius',
		dn: 'BorderRadius',
		n: 'iconBorderRadius<designType><colorScheme>',
	},
	{
		cp: 'padding',
		sel: '.comp.compIcon<designType><colorScheme>',
		np: true,
		spv: {
			'_default-': '6px',
			'_outlined-': '6px',
			'_filled-': '6px',
			'_rounded-': '6px',
		},
		gn: 'Padding',
		dn: 'Padding',
		n: 'iconPadding<designType><colorScheme>',
	},
];
